module.exports = __webpack_public_path__ + "Roboto-Bold.eed9aab5449cc9c8430d.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Bold.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold.woff
// module chunks = styles